import React from "react";
import Sidebar from "../../components/Sidebar";
import CurrencyTable from "./components/CurrencyTable";

const CurrencySettings = () => {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      <Sidebar />

      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-6">Currency Settings</h1>

        <div className="">
          <CurrencyTable />
        </div>
      </div>
    </div>
  );
};

export default CurrencySettings;
